import { ReactNode } from 'react';
import { PageHeader } from '@/components/ui/PageHeader';
import './ToolPage.css';

interface ToolPageProps {
  /** The tool's name, in sentence case, as it reads on the Tools page. */
  title: string;
  /** One sentence on what the tool does to a client. Shown under the title: a tool changes production. */
  subtitle?: ReactNode;
  /** `narrow` (about 720px) holds a single form. `wide` (the default) holds tables. */
  width?: 'narrow' | 'wide';
  /** Buttons and controls on the right of the title. */
  actions?: ReactNode;
  children: ReactNode;
}

/**
 * The frame every tool opens in: a way back to the Tools page, the page
 * header, then the tool itself at one of two widths.
 */
export function ToolPage({ title, subtitle, width = 'wide', actions, children }: ToolPageProps) {
  return (
    <div className={`tool-page tool-page--${width}`}>
      <PageHeader title={title} description={subtitle} actions={actions} back={{ to: '/tools', label: 'Tools' }} />
      {children}
    </div>
  );
}

export default ToolPage;
